import React from 'react';

// const TestimonialsPage = () => (
//   <div>
//     <h2 className="text-2xl font-bold mb-4">Testimonials</h2>
//     <div className="space-y-4">
//       <div>"Awesome trainers and wonderful ambience!" – Priya S.</div>
//       <div>"Yoga Studio changed my life." – Rahul M.</div>
//     </div>
//   </div>
// );

const TestimonialsPage = () => (
  <div className="p-8 bg-white rounded-lg shadow-xl">
    <h2 className="text-3xl font-bold text-gray-800 mb-6">What Our Members Say</h2>
    <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
      <div className="bg-blue-50 p-6 rounded-lg shadow-md border border-blue-200">
        <p className="italic text-gray-700 mb-4">"Joining Yoga Studio was the best decision I made for my well-being. The trainers are exceptional, and the community is so welcoming!"</p>
        <p className="font-semibold text-blue-700">- Jane Doe</p>
        <p className="text-sm text-gray-500">Regular Member since 2022</p>
      </div>
      <div className="bg-green-50 p-6 rounded-lg shadow-md border border-green-200">
        <p className="italic text-gray-700 mb-4">"I've tried several studios, but none compare to the quality of instruction and the serene atmosphere here. Highly recommend!"</p>
        <p className="font-semibold text-green-700">- John Smith</p>
        <p className="text-sm text-gray-500">Advanced Practitioner</p>
      </div>
      <div className="bg-purple-50 p-6 rounded-lg shadow-md border border-purple-200">
        <p className="italic text-gray-700 mb-4">"The prenatal yoga classes helped me immensely during my pregnancy. Emily is a fantastic and supportive trainer."</p>
        <p className="font-semibold text-purple-700">- Sarah Johnson</p>
        <p className="text-sm text-gray-500">New Mother</p>
      </div>
      <div className="bg-yellow-50 p-6 rounded-lg shadow-md border border-yellow-200">
        <p className="italic text-gray-700 mb-4">"The variety of classes and flexible schedule make it easy to fit yoga into my busy life. I feel stronger and more centered."</p>
        <p className="font-semibold text-yellow-700">- Michael Brown</p>
        <p className="text-sm text-gray-500">Weekend Warrior</p>
      </div>
    </div>
  </div>
);

export default TestimonialsPage;
